// @ts-ignore
import * as errorToolTip from '../general/errorToolTip';
import { TooltipDirection } from '../general/newErrorToolTip';
import { StretchPopup } from '../popups/stretchPopup';

export class LoginFormContent {
    private form: JQuery<HTMLElement>;
    private showTooltipOnLeft: boolean;

    public constructor(
        form: JQuery<HTMLElement>,
        tooltipDirection: string
    ) {
        this.form = form;
        this.showTooltipOnLeft = tooltipDirection.toLowerCase() === 'right';
    }


    public static fromForm(form: JQuery<HTMLElement>, tooltipDirection: TooltipDirection) {
        return new LoginFormContent(
            form,
            tooltipDirection
        );
    }

    public showEmailError(message: string) {
        const emailInputParent = this.getEmailInputParent();
        emailInputParent.addClass('error');
        errorToolTip(emailInputParent, this.showTooltipOnLeft, message);
    }

    public showPasswordError(message: string) {
        const passwordInputParent = this.getPasswordInputParent();
        passwordInputParent.addClass('error');
        errorToolTip(passwordInputParent, this.showTooltipOnLeft, message);
    }

    public showSubmitButtonError(message: string) {
        const submitButton = this.getSubmitButton();
        errorToolTip(submitButton, this.showTooltipOnLeft, message);
    }

    public show2FaError(message: string) {
        const auth2FaCodeInputParent = this.getAuth2FaCodeInputParent();
        auth2FaCodeInputParent.addClass('error');
        errorToolTip(auth2FaCodeInputParent, this.showTooltipOnLeft, message);
    }

    public show2FaForm() {
        this.getEmailInputParent().hide();
        this.getPasswordInputParent().hide();
        this.hideSocialLoginButtons();
        $('.login-2fa-info', this.form).show();
        $('.forgot-pass-button', this.form).hide();
        this.getAuth2FaCodeInputParent().show();
        StretchPopup.stretch();
        $('.forgot-pass-button', this.form).one('click', () => {
            this.returnToLoginForm();
        });
    }

    public returnToLoginForm() {
        this.getEmailInputParent().show();
        this.getPasswordInputParent().show();
        this.showSocialLoginButtons();
        $('.login-2fa-info', this.form).hide();
        $('.forgot-pass-button', this.form).show();
        this.getAuth2FaCodeInputParent().hide();
        StretchPopup.stretch();
    }

    public hideErrors() {
        this.getEmailInputParent().removeClass('error');
        this.getPasswordInputParent().removeClass('error');
    }

    public hideSocialLoginButtons() {
        $('.social-login-buttons-block', this.form).hide();
    }

    public showSocialLoginButtons() {
        $('.social-login-buttons-block', this.form).show();
    }

    private getEmailInputParent() {
        return $('input[name=email]', this.form).parent();
    }

    private getPasswordInputParent() {
        return $('input[name=password]', this.form).parent();
    }

    private getAuth2FaCodeInputParent() {
        return $('input[name=login_2fa_code]', this.form).parent();
    }

    private getSubmitButton() {
        return $('button[type=submit]', this.form).parent();
    }
}
